import { Subject } from 'rxjs';

export function createModalService() {
  const subject = new Subject();

  return {
    clearHtml: () => subject.next({ action: 'clearHtml' }),
    getHtml: () => subject.asObservable(),
    onHtmlReady: (data) => subject.next({ action: 'onHtmlReady', ...data }),
    onHtmlRemoved: (data) => subject.next({ action: 'onHtmlRemoved', ...data }),
    setHtml: (data) => subject.next({ action: 'setHtml', value: data.payload }),
    setPreviousHtml: () => subject.next({ action: 'setPreviousHtml' }),
  };
}

export default createModalService();
